/**
 * A jelenlegi láthatóság naplójelölése (`trace.ts`).
 *
 * KÜLÖN FÁJLBAN, mert a `trace.ts` típusai a `types.ts`-en át a szerver
 * fordításába is bekerülnek, ahol nincs DOM — ez a modul csak a kliensé.
 * DOM nélkül (teszt, worker) előtér.
 */
export function currentTraceVisibility(): 'f' | 'b' {
  try {
    return document.visibilityState === 'hidden' ? 'b' : 'f';
  } catch {
    return 'f';
  }
}
